import { useCallback, useState } from 'react';
import { agreementsPlatformApi } from '@/modules/agreements/services/platform-api';
import { useAsyncResource } from '@/shared/hooks/use-async-resource';
import { isForbidden } from '@/modules/agreements/shared';

/**
 * The document detail page's data and its selected version.
 *
 * A requirement is configured against a SPECIFIC version, so the page tracks which version
 * the operator has selected.
 */
export function useDocumentDetail(documentId: string) {
  const load = useCallback(
    () => agreementsPlatformApi.getDocument(documentId),
    [documentId],
  );
  const { data, error, isLoading, reload } = useAsyncResource(load);
  const [selectedVersionId, setSelectedVersionId] = useState<string | null>(null);

  return {
    document: data,
    error,
    isLoading,
    reload,
    isDenied: isForbidden(error),
    selectedVersionId,
    setSelectedVersionId,
  };
}
